import { Input } from 'components/Input'
import { Select } from '../../../../../components/Select'
import { useRebateConditionsFormContext } from '../Providers/RebateConditionsFormProvider'
import {
  isEmptyValue,
  percentageRebateValidator
} from 'features/ContractDetails/RebateConditions/RebateConditionsForm/utils'
import { LABELS, PLACEHOLDERS } from 'constants/txt'
import { PROPS_INPUT_NUMBER } from 'features/ContractDetails/RebateConditions/RebateConditionsForm/constants'
import { StraightRebateProps } from './types'
import { RowLayout } from 'features/MyCommunity/Vendors/VendorCreation/General/VendorForm/RowLayout'
import { Separator } from 'components/Separator/Separator'

const StraightRebateCondition = ({ handleChangeForm }: StraightRebateProps) => {
  const { thresholdPeriodOptions } = useRebateConditionsFormContext()

  return (
    <>
      <Separator />
      <RowLayout title="Rebate conditions">
        <div className="row gap-12">
          <Input.Number
            propsItem={{
              name: 'amount',
              label: LABELS.REBATE_AMOUNT,
              rules: [
                {
                  validator: (_, value) => {
                    if (isEmptyValue(value)) {
                      return Promise.resolve()
                    }
                    return percentageRebateValidator(_, value)
                  }
                }
              ]
            }}
            propsInputNumber={PROPS_INPUT_NUMBER}
          />
          <Select
            options={thresholdPeriodOptions}
            propsItem={{
              name: 'period_threshold',
              label: LABELS.PERIOD_THRESHOLD
            }}
            propsSelect={{
              placeholder: PLACEHOLDERS.PLEASE_SELECT,
              onChange: handleChangeForm
            }}
          />
        </div>
      </RowLayout>
    </>
  )
}

export default StraightRebateCondition
